export const REAL_ESTATE_LISTINGS_URL = "https://onepropertee.com/deo-bernal";

export const REAL_ESTATE_LISTINGS = [
  {
    title: "Two adjacent residential lots in Pandacaqui-Telapayong",
    price: "₱1.50 million",
    meta: "192 sqm · Mexico, Pampanga · For sale",
  },
  {
    title: "Semi-commercial lot in Pandacaqui",
    price: "₱2.50 million",
    meta: "180 sqm · Mexico, Pampanga · For sale",
  },
] as const;
